import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceResource } from '../model/serviceResource';
import { CreateCalculationRequest } from '../model/createCalculationRequest';
import { CalculationResource } from '../model/calculationResource';
import { CreateCustomerRequest } from '../model/createCustomerRequest';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ThirdStepService {

  apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  assignCustomer(calculationId: string, params: CreateCustomerRequest): Observable<CalculationResource> {
    const apiUrl = this.apiUrl+'/api/calculation/'+calculationId+'/customer';
    return this.http.post<CalculationResource>(apiUrl, params); // Specify the return type
  }

}
